/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import errorPageStyle from "assets/jss/material-kit-pro-react/views/errorPageStyles.js";

import image from "assets/img/clint-mckoy.jpg";
import mcCannLogo from '../../assets/img/fpmccann white.png';

import { useSelector } from "react-redux";

const useStyles = makeStyles(errorPageStyle);

export default function ErrorPage({ ...rest }) {
    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    });

    const errorMessage = useSelector(state => state.orderReducer.errorMessage);

    const classes = useStyles();
    return (
        <div>
            <Header
                brand={
                    <div style={{ textAlign: "center" }}>

                        <img
                            src={mcCannLogo}
                            height={50}
                            width={75}
                            alt="FPMcCannLogo"
                        />
                        {' '}
                        {/*            <b> Easi-Order Portal</b>*/}

                    </div>}
                links={<HeaderLinks dropdownHoverColor="info" />}
                fixed
                color="transparent"
                changeColorOnScroll={{
                    height: 50,
                    color: "info",

                }}>
            </Header>
            <div
                className={classes.pageHeader}
                style={{
                    backgroundColor:'#3A6986',
                    backgroundSize: "cover",
                    backgroundPosition: "top center"
                }}
            >
                {/* <div className={classes.container}> */}
                <div className={classes.contentCenter}>
                    <GridContainer>
                        <GridItem md={12}>
                            <h3 className={classes.title}>Error</h3>
                            <h5 className={classes.subTitle}>{errorMessage}</h5>
                            <h4 className={classes.description}>
                                <b>Please contact FP McCann Sales team.</b>
                            </h4>
                        </GridItem>
                    </GridContainer>
                </div>
                {/* </div> */}
            </div>
            
        </div>
    );
}
